import { render, staticRenderFns } from "./workSpecialClasses.vue?vue&type=template&id=4dd1767c&scoped=true&"
import script from "./workSpecialClasses.vue?vue&type=script&lang=js&"
export * from "./workSpecialClasses.vue?vue&type=script&lang=js&"
import style0 from "./workSpecialClasses.vue?vue&type=style&index=0&id=4dd1767c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1767c",
  null
  
)

export default component.exports